import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { createAppAsyncThunk } from '../utils/reduxUtil';
import getAllMyTransactions from '../services/transaction';
import { GetTransactionParams } from '../models/payload/transaction';
import { MyTransactionsResponse } from '../models/response/transaction';

interface UserTransactionsStateInterface {
  loading: boolean;
  transactions: MyTransactionsResponse | undefined;
}

const initialState: UserTransactionsStateInterface = {
  loading: false,
  transactions: undefined,
};

const getMyTransactions = createAppAsyncThunk<MyTransactionsResponse, GetTransactionParams>(
  'transactions/myTransactions',
  async (params) => {
    const response = await getAllMyTransactions(params);
    return response;
  }
);

const reportSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<UserTransactionsStateInterface>) => {
    builder.addCase(getMyTransactions.pending, (state) => ({
      ...state,
      loading: true,
    }));

    builder.addCase(getMyTransactions.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      transactions: action.payload,
    }));
  },
});

export default reportSlice;
export { getMyTransactions };
